import React from 'react';
import { Box, Text, Image, Heading } from 'pcln-design-system';
function generateContentfulImageQueryParams(image) {
  const queryParams = ['fm=webp'];
  if (image?.quality) {
    queryParams.push(`q=${image.quality}`);
  }
  if (image?.width) {
    queryParams.push(`w=${image.width}`);
  }
  if (image?.height) {
    queryParams.push(`h=${image.height}`);
  }
  return queryParams.join('&');
}
export default function MediaSnippet({
  image,
  heading,
  paragraph
}) {
  const fastlyQueryParams = generateContentfulImageQueryParams(image);
  return React.createElement(Box, {
    px: 2,
    as: 'section'
  }, React.createElement(Image, {
    m: 'auto',
    pb: 3,
    src: `${image.asset.file.url}?${fastlyQueryParams}`,
    alt: image.altText,
    loading: 'lazy',
    height: ['440px', null, null, null, null, '500px']
  }), heading && React.createElement(Heading, {
    as: 'h2',
    textStyle: 'heading4',
    pb: 2,
    m: 0,
    textAlign: 'center'
  }, heading), paragraph && React.createElement(Text, {
    pb: 3,
    textStyle: 'paragraph',
    textAlign: 'center'
  }, paragraph));
}